export default {
  discoveryServiceUrl: process.env.VUE_APP_DISCOVERY_URL,
  tokenServiceUrl: process.env.VUE_APP_TOKEN_SERVICE_URL,
  reportAnalyticsServiceUrl: process.env.VUE_APP_REPORT_ANALYTICS_SERVICE_URL,
  npsServiceUrl: process.env.VUE_APP_NPS_SERVICE_URL,
  lrsServiceUrl: process.env.VUE_APP_REPORT_SERVICE_URL,
  authServiceUrl: process.env.VUE_APP_AUTH_SERVICE_URL,
  editorServiceUrl: process.env.VUE_APP_EDITOR_SERVICE_URL,
  editorClientUrl: process.env.VUE_APP_EDITOR_CLIENT_URL,
  resultsClientUrl: process.env.VUE_APP_RESULTS_CLIENT_URL,
  segmentAppId: process.env.VUE_APP_SEGMENT_APP_ID,
  featureFlagsClientKey: process.env.VUE_APP_FEATURE_FLAGS_CLIENT_KEY,
  featureFlagsServiceUrl: process.env.VUE_APP_FEATURE_FLAGS_SERVICE_URL,
  translationServiceUrl: process.env.VUE_APP_TRANSLATION_SERVICE_URL,
  mixpanelProjectToken: process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN,
  mixpanelProjectName: process.env.VUE_APP_MIXPANEL_PROJECT_NAME,
  analyticsEnabled: process.env.VUE_APP_ANALYTICS_ENABLED,
  nativeMixpanelProjectToken: process.env.VUE_APP_NATIVE_MIXPANEL_PROJECT_TOKEN,
  nativeMixpanelProjectName: process.env.VUE_APP_NATIVE_MIXPANEL_PROJECT_NAME,
};
